import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'react-datepicker/dist/react-datepicker.css';
import {
    Accordion,
    Badge,
    Button,
    Col,
    Container,
    Form,
    Image,
    InputGroup,
    Modal,
    Row,
    Tab,
    Tabs
} from "react-bootstrap";
import CercaIcon from "./icons/cerca.png"
import PuntatoreIcon from "./icons/puntatore.png"
import TargetIcon from "./icons/target.png"
import TargetBlackIcon from "./icons/target_black.png"
import TemaBlackIcon from "./icons/tema_black.png"
import TemaIcon from "./icons/tema.png"
import CalendarioIcon from "./icons/calendario.png"
import LinkIcon from "./icons/link.png"
import CatSoggettoIcon from "./icons/cat_soggetto.png"
import OrganizzatoreIcon from "./icons/organizzatore.png"
import {useEffect, useState} from "react";
import DatePicker from "react-datepicker"

function App() {

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [targets, setTargets] = useState([
            {valore: "targetAdolescenti", descrizione: "Adolescenti"},
            {valore: "targetAdulti", descrizione: "Adulti"},
            {valore: "targetAnziani", descrizione: "Anziani"},
            {valore: "targetBambini", descrizione: "Bambini"},
            {valore: "targetDegenti", descrizione: "Degenti"},
            {valore: "targetDetenuti", descrizione: "Detenuti"},
            {valore: "targetDonne", descrizione: "Donne"},
            {valore: "targetInsegnanti", descrizione: "Insegnanti"},
            {valore: "targetProfessionisti", descrizione: "Professionisti"},
            {valore: "targetStranieri", descrizione: "Stranieri"},
            {valore: "targetStudenti", descrizione: "Studenti"}
        ]
    )


    const [temi, setTemi] = useState([
            {valore: "temaArchitettura", descrizione: "Architettura"},
            {valore: "temaArti", descrizione: "Arti"},
            {valore: "temaArtiVisive", descrizione: "Arti Visive"},
            {valore: "temaFolklore", descrizione: "Folklore"},
            {valore: "temaLetteratura", descrizione: "Letteratura"},
            {valore: "temaPaesaggio", descrizione: "Paesaggio"},
            {valore: "temaScienza", descrizione: "Scienza"},
            {valore: "temaSociale", descrizione: "Sociale"},
            {valore: "temaStoria", descrizione: "Storia"}
        ]
    )

    const [listTipoOrganizzatore, setListTipoOrganizzatore] = useState([])
    const [tipoOrganizzatore, setTipoOrganizzatore] = useState("")

    const [regioni, setRegioni] = useState([])
    const [regione, setRegione] = useState("")

    const [province, setProvince] = useState([])
    const [provinceFiltrate, setProvinceFiltrate] = useState([])
    const [provincia, setProvincia] = useState("")


    const [comuni, setComuni] = useState([])
    const [comuniFiltrati, setComuniFiltrati] = useState([])
    const [comune, setComune] = useState("")

    const [target, setTarget] = useState("")
    const [tema, setTema] = useState("")


    const [iniziative, setIniziative] = useState([])
    const [organizzatori, setOrganizzatori] = useState([])
    const [sedi, setSedi] = useState([])
    const [dateSedi, setDateSedi] = useState([])
    const [parola, setParola] = useState("")
    const [denominazioneOrganizzatore, setDenominazioneOrganizzatore] = useState("")
    const [uniqueCode, setUniqueCode] = useState("")

    useEffect(() => {
        const provinceFiltrate = province.filter(provincia => provincia?.regioneId === regione);
        setProvinceFiltrate(provinceFiltrate)
    }, [regione])

    useEffect(() => {
        const comuniFiltrati = comuni.filter(comune => comune?.provinciaId === provincia);
        setComuniFiltrati(comuniFiltrati)
    }, [provincia])


    function extractDateInfo(dateStr) {
        const months = ["GEN", "FEB", "MAR", "APR", "MAG", "GIU", "LUG", "AGO", "SET", "OTT", "NOV", "DIC"];

        // Dividi la stringa di data in componenti
        const parts = dateStr.split("/");

        // Estrai giorno, mese e anno
        const day = parseInt(parts[0], 10); // Converti in numero rimuovendo gli zeri iniziali
        const monthIndex = parseInt(parts[1], 10) - 1; // Converti in indice mese (0-11)
        const year = parseInt(parts[2], 10); // Anno

        // Formatta mese, giorno e anno
        const month = months[monthIndex];

        return {month, day, year};
    }


    const cerca = () => {
        fetch(`https://www.ilmaggiodeilibri.cepell.it/registrazione/LoadIniziative.php?annoIniziativa=2023
        ${target !== "" ? `&${target}=1` : ''}
        ${tema !== "" ? `&${tema}=1` : ''}
        &titolo=${parola.trim()}
        &regioneId=${regione}
        &provinciaId=${provincia}
        &comuneId=${comune}`)
            .then(response => response.json())
            .then(data => {
                setIniziative(data?.iniziative)
                setOrganizzatori(data?.organizzatori)
                setSedi(data?.sedi)
                setDateSedi(data?.dateSedi)
            })
            .catch(error => console.error(error));
    }


    const generateTargetBadges = (iniziativa) => {
        const targetPrefix = 'target';
        return Object.keys(iniziativa)
            .filter(key => key.startsWith(targetPrefix) && iniziativa[key] === "1")
            .map(key => {
                // Converti la chiave in un formato leggibile, es. TargetAdolescenti => Adolescenti
                const targetName = key.substring(targetPrefix.length)
                    .replace(/([A-Z])/g, ' $1') // Aggiungi spazio prima delle maiuscole
                    .trim(); // Rimuovi spazi iniziali e finali

                return (
                    <Badge key={key} pill className={"m-1 c-target-badge"}>
                        {targetName}
                    </Badge>
                );
            });
    };


    const generateThemeBadges = (iniziativa) => {
        const themePrefix = 'tema';
        return Object.keys(iniziativa)
            .filter(key => key.startsWith(themePrefix) && iniziativa[key] === "1")
            .map(key => {
                const themeName = key.substring(themePrefix.length)
                    .replace(/([A-Z])/g, ' $1')
                    .trim();

                return (
                    <Badge key={key} pill className="m-1 c-target-badge">
                        {themeName}
                    </Badge>
                );
            });
    };

    useEffect(() => {
        //load regioni
        fetch('https://www.ilmaggiodeilibri.cepell.it/registrazione/LoadRegioni.php')
            .then(response => response.json())
            .then(data => setRegioni(data))
            .catch(error => console.error(error));

        fetch('https://www.ilmaggiodeilibri.cepell.it/registrazione/LoadProvince.php')
            .then(response => response.json())
            .then(data => setProvince(data))
            .catch(error => console.error(error));


        fetch('https://www.ilmaggiodeilibri.cepell.it/registrazione/LoadComuni.php')
            .then(response => response.json())
            .then(data => setComuni(data))
            .catch(error => console.error(error));

        fetch('https://www.ilmaggiodeilibri.cepell.it/registrazione/LoadCategoriaOrganizzatore.php')
            .then(response => response.json())
            .then(data => setListTipoOrganizzatore(data))
            .catch(error => console.error(error));

        cerca()
    }, [])


    const getOrganizzatoriIniziativa = (iniziativaId) => {
        return organizzatori.filter(organizzatore => organizzatore?.iniziativaId === iniziativaId)
    }

    const getSediIniziativa = (iniziativaId) => {
        return sedi.filter(sede => sede?.iniziativaId === iniziativaId)
    }

    const getDateSediIniziativa = (sedeId) => {
        return dateSedi.filter(dataSede => dataSede?.sedeId === sedeId)
    }

    const getComune = (comuneId) => {
        return comuni.filter(comune => comune?.id === comuneId)[0]
    }

    const getProvincia = (comuneId) => {
        const comune = getComune(comuneId)
        return province.filter(provincia => provincia?.id === comune?.provinciaId)[0]
    }

    const getRegione = (comuneId) => {
        const provincia = getProvincia(comuneId)
        return regioni.filter(regione => regione?.id === provincia?.regioneId)[0]
    }

    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)
    const [locandina, setLocandina] = useState('')

    return (
        <Container fluid>
            <Row className={"d-flex justify-content-between align-items-baseline"}>
                <Col sm={"auto"}>
                    <h1 className="section-title">Appuntamenti</h1>
                </Col>
                <Col sm={"auto"}>
                    <Badge pill className={"c-bg-rosso text-white px-4 py-2 mx-2 h6"}>
                        {iniziative.length}
                    </Badge>
                    Attività totali
                </Col>
            </Row>

            <Form className={"p-4"} style={{backgroundColor: "#fff"}}>

                <Row className={"d-flex align-items-baseline my-4"}>
                    <Col sm={8} className={"text-right"}>
                        <InputGroup className="w-100">
                            <InputGroup.Text id="parola_chiave" className={"c-icona-input"}>
                                <Image width={15} src={CercaIcon}></Image>
                            </InputGroup.Text>
                            <Form.Control
                                onChange={e => setParola(e.target.value)}
                                className={"c-form-control"}
                                placeholder="Parola chiave"
                                aria-label="parola_chiave"
                                aria-describedby="parola_chiave"
                            />

                        </InputGroup>
                        <Form.Text id="parola_chiave_help" muted>
                            *Il testo inserito viene ricercato nel titolo, nella descrizione o nel campo ospiti
                            dell’iniziativa
                        </Form.Text>
                    </Col>
                    <Col sm={4}>
                        <Row className={"d-flex"}>
                            <Col sm={"auto"}><Button variant={"danger"} onClick={() => cerca()}>Cerca</Button></Col>
                            <Col sm={"auto"}><Button variant={"outline-danger"}>Annulla</Button></Col>
                        </Row>
                    </Col>
                </Row>
                <Row className={"d-flex align-items-end my-4"}>
                    <Col sm={4}>
                        <InputGroup className="w-100">
                            <InputGroup.Text id="parola_chiave" className={"c-icona-input"}>
                                <Image width={15} src={PuntatoreIcon}></Image>
                            </InputGroup.Text>
                            <Form.Select
                                onChange={(e) => setRegione(e.target.value)}
                                aria-label="Regione" className={"c-form-control"} aria-placeholder={"regione"}>
                                <option disabled selected>Regione</option>
                                {regioni.map((regione, index) => {
                                    return <option key={index} value={regione.id}>{regione.nome}</option>
                                })}
                            </Form.Select>
                        </InputGroup>
                    </Col>


                    <Col sm={4}>
                        <InputGroup className="w-100">
                            <InputGroup.Text id="provincia" className={"c-icona-input"}>
                                <Image width={15} src={PuntatoreIcon}></Image>
                            </InputGroup.Text>
                            <Form.Select
                                onChange={(e) => setProvincia(e.target.value)}
                                aria-label="Provincia" className={"c-form-control"}>
                                <option disabled selected>Provincia</option>
                                {provinceFiltrate.map((provincia, index) => {
                                    return <option key={index} value={provincia.id}>{provincia.nome}</option>
                                })}
                            </Form.Select>
                        </InputGroup>
                    </Col>


                    <Col sm={4}>
                        <InputGroup className="w-100">
                            <InputGroup.Text id="localita" className={"c-icona-input"}>
                                <Image width={15} src={PuntatoreIcon}></Image>
                            </InputGroup.Text>
                            <Form.Select
                                onChange={(e) => setComune(e.target.value)}
                                aria-label="Località" className={"c-form-control"}>
                                <option disabled selected>Comune</option>
                                {comuniFiltrati.map((comune, index) => {
                                    return <option key={index} value={comune.id}>{comune.nome}</option>
                                })}
                            </Form.Select>
                        </InputGroup>
                    </Col>
                </Row>
                <Row className={"d-flex align-items-end my-4"}>
                    <Col sm={2}>

                            <DatePicker
                                icon={
                                    <Image width={15} src={CalendarioIcon}></Image>
                                }
                                showIcon
                                placeholderText='Dal'
                                className={"c-form-control form-control"} selected={startDate} onChange={(date) => setStartDate(date)} />


                    </Col>

                    <Col sm={2}>
                        <DatePicker
                            icon={
                                <Image width={15} src={CalendarioIcon}></Image>
                            }
                            showIcon
                            placeholderText='Fino al'
                            className={"c-form-control form-control"} selected={endDate} onChange={(date) => setEndDate(date)} />


                    </Col>

                    <Col sm={4}>
                        <InputGroup className="w-100">
                            <InputGroup.Text id="target" className={"c-icona-input"}>
                                <Image width={15} src={TargetIcon}></Image>
                            </InputGroup.Text>
                            <Form.Select
                                onChange={(e) => setTarget(e.target.value)}
                                aria-label="Target" className={"c-form-control"}>
                                <option disabled selected>Target</option>
                                {targets.map((target, index) => {
                                    return <option key={index} value={target.valore}>{target.descrizione}</option>
                                })}
                            </Form.Select>
                        </InputGroup>
                    </Col>


                    <Col sm={4}>
                        <InputGroup className="w-100">
                            <InputGroup.Text id="tema" className={"c-icona-input"}>
                                <Image width={15} src={TemaIcon}></Image>
                            </InputGroup.Text>
                            <Form.Select
                                onChange={(e) => setTema(e.target.value)}
                                aria-label="Tema" className={"c-form-control"}>
                                <option disabled selected>Tema</option>
                                {temi.map((tema, index) => {
                                    return <option key={index} value={tema.valore}>{tema.descrizione}</option>
                                })}
                            </Form.Select>
                        </InputGroup>
                    </Col>
                </Row>

                <Row className={"d-flex justify-content-end"}>
                    <Col sm={"auto"}>
                        <Form.Check type={"checkbox"} id={`web`} className={"text-danger"}>
                            <Form.Check.Input type={"checkbox"}/>
                            <Form.Check.Label>{`Appuntamento Web`}</Form.Check.Label>
                        </Form.Check>
                    </Col>
                </Row>

                <div className={"d-flex justify-content-center"} style={{backgroundColor: "#414C55"}}>
                    <div className={"w-100"}>
                        <Accordion className={"c-ricerca-avanzata"}>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header className={"d-flex"}>
                                    <h5 className={"text-white font-weight-bold mt-2 py-1"}>RICERCA AVANZATA <i className="fa fa-angle-down text-white"/></h5>
                                </Accordion.Header>
                                <Accordion.Body style={{backgroundColor: "#f2f4f6"}} className={"py-4 px-2"}>

                                    <Row className={"d-flex align-items-baseline justify-content-center"}>
                                        <Col sm={4}>
                                            <Form.Control
                                                onChange={e => setDenominazioneOrganizzatore(e.target.value)}
                                                className={"c-form-control"}
                                                placeholder="Denominazione organizzatore..."
                                                aria-label="denom_organizzatore"
                                                aria-describedby="denom_organizzatore"
                                            />
                                        </Col>
                                        <Col sm={4}>
                                            <InputGroup className="w-100">
                                                <InputGroup.Text id="tema" className={"c-icona-input"}>
                                                    <Image width={15} src={OrganizzatoreIcon}></Image>
                                                </InputGroup.Text>
                                                <Form.Select
                                                    onChange={(e) => setTipoOrganizzatore(e.target.value)}
                                                    aria-label="Tipologia organizzatore" className={"c-form-control"}>
                                                    <option disabled selected>Tipologia organizzatore</option>
                                                    {listTipoOrganizzatore.map((tipo, index) => {
                                                        return <option key={index} value={tipo.id}>{tipo.denominazione}</option>
                                                    })}
                                                </Form.Select>
                                            </InputGroup>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Control
                                                onChange={e => setUniqueCode(e.target.value)}
                                                className={"c-form-control"}
                                                placeholder="Unique-code"
                                                aria-label="Unique-code"
                                                aria-describedby="Unique-code"
                                            />
                                        </Col>
                                    </Row>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>

            </Form>


            <Row className={"my-4"}>
                <Col sm={12}>
                    <Accordion>

                        {iniziative.map((iniziativa, index) => {
                            const organizzatore = getOrganizzatoriIniziativa(iniziativa.id)[0]
                            const sede = getSediIniziativa(iniziativa.id)[0]
                            const dataSede = getDateSediIniziativa(sede.id)[0]


                            console.log('dataSede', dataSede)
                            return (
                                <Accordion.Item eventKey={index} className={"my-4"}>
                                    <Accordion.Header className={"c-accordio-appuntamento w-100"}>
                                        <Row className={"d-flex"}>
                                            <Col sm={3} className={"d-flex justify-content-center my-4 bordo-destro"}>
                                                {dataSede.daData !== dataSede.aData ?
                                                    <>
                                                        <div style={{width: "fit-content"}}>
                                                            <div
                                                                className={"mx-3 d-flex flex-column align-items-center c-appuntamento-row"}>
                                                                <span className={"dal ml-2 my-1"}>Dal</span>
                                                                <span
                                                                    className={"mese ml-2 my-1"}>{extractDateInfo(dataSede.daData).month}</span>
                                                                <span
                                                                    className={"giorno font-weight-bold"}>{extractDateInfo(dataSede.daData).day}</span>
                                                                <span
                                                                    className={"anno my-1"}>{extractDateInfo(dataSede.daData).year}</span>
                                                            </div>
                                                        </div>
                                                        <div style={{width: "fit-content"}}>
                                                            <div
                                                                className={"mx-3 d-flex flex-column align-items-center c-appuntamento-row"}>
                                                                <span className={"al ml-2 my-1"}>Al</span>
                                                                <span
                                                                    className={"mese ml-2 my-1"}>{extractDateInfo(dataSede.aData).month}</span>
                                                                <span
                                                                    className={"giorno font-weight-bold"}>{extractDateInfo(dataSede.aData).day}</span>
                                                                <span
                                                                    className={"anno my-1"}>{extractDateInfo(dataSede.aData).year}</span>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <div style={{width: "fit-content"}} >
                                                        <div
                                                            className={"mx-3 mt-4 d-flex flex-column align-items-center c-appuntamento-row"}>
                                                            <span
                                                                className={"mese ml-2 my-1"}>{extractDateInfo(dataSede.daData).month}</span>
                                                            <span
                                                                className={"giorno font-weight-bold"}>{extractDateInfo(dataSede.daData).day}</span>
                                                            <span
                                                                className={"anno my-1"}>{extractDateInfo(dataSede.daData).year}</span>
                                                        </div>
                                                    </div>
                                                }
                                            </Col>

                                            <Col sm={7} className={"my-4 px-4"}>

                                                <Row>
                                                    <Col sm={12} className={"d-flex "}>
                                                        <p style={{
                                                            paddingRight: "24px",
                                                            borderRight: "2px solid #444"
                                                        }}>Unique Code: <span
                                                            className={"text-danger"}>{iniziativa.uniqueCode}</span></p>
                                                        <p style={{
                                                            paddingLeft: "24px",
                                                        }}>Attività: <span
                                                            className={"text-danger"}>{iniziativa.nattivita}</span></p>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col className={"text-left"}>
                                                        <h4 className={"font-weight-bold"}>
                                                            {iniziativa.titolo}
                                                        </h4>
                                                    </Col>
                                                </Row>

                                                <Row className={"mt-2"}>
                                                    <Col sm={12} className={"d-flex "}>
                                                        <p className={"font-weight-bold"}>REGIONE: <Badge pill
                                                                                                          className={"text-uppercase c-bg-rosa text-white px-4 py-2 mx-2"}>
                                                            {getRegione(organizzatore.comuneId)?.nome}</Badge></p>
                                                        <p className={"font-weight-bold"}>LOCALITA': <Badge pill
                                                                                                            className={"text-uppercase c-bg-rosa text-white px-4 py-2 mx-2"}>{getComune(organizzatore.comuneId)?.nome}</Badge>
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col sm={2}>
                                                {iniziativa.locandina !== null ?
                                                    <Image
                                                        className={"mt-4"}
                                                        onClick={(e)=> {
                                                            setLocandina(`https://www.ilmaggiodeilibri.cepell.it/registrazione/${iniziativa.locandina}`)
                                                            handleShow()
                                                            e.stopPropagation()
                                                        }}
                                                        width={120}
                                                        src={`https://www.ilmaggiodeilibri.cepell.it/registrazione/${iniziativa.locandina}`}></Image>
                                                    : ''}

                                            </Col>
                                        </Row>

                                        <div className={"c-accordion-button"}>
                                            <i className="fa fa-angle-down text-white"/>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body className={"c-accordion-body"}>
                                        <Row>
                                            <Col sm={12}>
                                                <Tabs
                                                    defaultActiveKey="dati"
                                                    id="uncontrolled-tab-example"
                                                    className="ml-4 pt-4"
                                                >
                                                    <Tab eventKey="dati" title="Dati Principali"
                                                         className=" ml-4 p-4 c-tab">
                                                        <Row>
                                                            <Col sm={8}>
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div className={"d-flex flex-column mb-2"}>
                                                                            <h4 className={"c-h4 font-weight-bold"}>Descrizione</h4>
                                                                            <span className={"c-underline"}></span>
                                                                        </div>
                                                                        <p>
                                                                            {iniziativa.descrizione}
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                                {iniziativa.ospiti !== '' ?<Row>
                                                                    <Col sm={12}>
                                                                        <div className={"d-flex flex-column mb-2"}>
                                                                            <h4 className={"c-h4 font-weight-bold"}>Ospiti
                                                                                della
                                                                                manifestazione</h4>
                                                                            <span className={"c-underline"}></span>
                                                                        </div>
                                                                        <p>
                                                                            {iniziativa.ospiti}
                                                                        </p>
                                                                    </Col>
                                                                </Row>:''}
                                                            </Col>

                                                            <Col sm={4}>

                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div className={"d-flex flex-row"}>
                                                                            <Image height={15} width={25}
                                                                                   src={TargetBlackIcon}/>
                                                                            <span
                                                                                className={"c-lable-right"}>Target</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className={"mt-3"}>
                                                                    <Col sm={12}>
                                                                        {generateTargetBadges(iniziativa)}
                                                                    </Col>
                                                                </Row>
                                                                <hR/>


                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div className={"d-flex flex-row"}>
                                                                            <Image height={15} width={25}
                                                                                   src={TemaBlackIcon}/>
                                                                            <span
                                                                                className={"c-lable-right"}>Temi</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className={"mt-3"}>
                                                                    <Col sm={12}>
                                                                        {generateThemeBadges(iniziativa)}
                                                                    </Col>
                                                                </Row>
                                                                <hR/>


                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div className={"d-flex flex-row"}>
                                                                            <i className="fa fa-phone"
                                                                               style={{fontSize: "1.8rem"}}
                                                                               aria-hidden="true"></i>

                                                                            <span
                                                                                className={"c-lable-right"}>Contatti</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className={"mt-3"}>
                                                                    <Col sm={12}>
                                                                        <ul>
                                                                            <li>
                                                                                {iniziativa.iniTelefono}
                                                                            </li>
                                                                            <li>
                                                                                {iniziativa.iniEmail}
                                                                            </li>
                                                                            <li>
                                                                                {iniziativa.iniWeb}
                                                                            </li>
                                                                        </ul>
                                                                    </Col>
                                                                </Row>
                                                                <hR/>


                                                            </Col>
                                                        </Row>

                                                        <div className={"d-flex justify-content-center"}>
                                                            <Button size={"lg"} className={"c-button-copia"}
                                                                    variant={"secondary"} onClick={() => {
                                                                navigator.clipboard.writeText(`https://www.ilmaggiodeilibri.cepell.it/appuntamenti?`);
                                                                alert("Link copiato negli appunti!");
                                                            }}>
                                                                <Image width={20} src={LinkIcon}/> Copia link</Button>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="organizzatori" title="Organizzatori"
                                                         className=" ml-4 p-4 c-tab">
                                                        <Row>
                                                            <Col sm={9}>
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div className={"d-flex flex-column mb-2"}>
                                                                            <h4 className={"c-h4 font-weight-bold"}>{organizzatore.denominazione}</h4>
                                                                            <span className={"c-underline"}></span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={8}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Via</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={organizzatore.via}/>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col sm={2}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>N°</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={organizzatore.numeroCivico}/>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col sm={2}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>CAP</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={organizzatore.cap}/>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>


                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Regione</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={getRegione(sede.comuneId)?.nome}/>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col sm={6}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Provincia</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={getProvincia(sede.comuneId)?.nome}/>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Comune</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={getComune(organizzatore.comuneId)?.nome}/>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col sm={6}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Località</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={getComune(organizzatore.comuneId)?.nome}/>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>

                                                            </Col>

                                                            <Col sm={3} style={{padding: 0}}>
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div className={"d-flex flex-row"}>
                                                                            <Image height={15} width={25}
                                                                                   src={CatSoggettoIcon}/>
                                                                            <span className={"c-lable-right"}>Categoria Soggetto</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <p
                                                                        className={"m-3 font-weight-bold"}>Biblioteche e
                                                                        mediateche</p>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Tab>

                                                    <Tab eventKey="sedi" title="Sedi" className=" ml-4 p-4 c-tab">
                                                        <Row>
                                                            <Col sm={12}>
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div className={"d-flex flex-column mb-2"}>
                                                                            <h4 className={"c-h4 font-weight-bold"}>{sede.denominazione}</h4>
                                                                            <span className={"c-underline"}></span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={8}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Via</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text" value={sede.via}/>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col sm={2}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>N°</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={sede.numeroCivico}/>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col sm={2}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>CAP</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text" value={sede.cap}/>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>


                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Regione</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={getRegione(sede.comuneId)?.nome}/>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col sm={6}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Provincia</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={getProvincia(sede.comuneId)?.nome}/>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Comune</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={getComune(sede.comuneId)?.nome}/>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col sm={6}>
                                                                        <Form.Group className="mb-3"
                                                                                    controlId="exampleForm.ControlInput1">
                                                                            <Form.Label>Località</Form.Label>
                                                                            <Form.Control
                                                                                className={"c-input-organizzaotore"}
                                                                                disabled type="text"
                                                                                value={getComune(sede.comuneId)?.nome}/>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>

                                                            </Col>
                                                        </Row>
                                                    </Tab>
                                                </Tabs>
                                            </Col>
                                        </Row>

                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        })}
                    </Accordion>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose}
                   centered
                   size="xl">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        className={"m-2"}
                        width={"100%"}
                        src={locandina}></Image>
                </Modal.Body>
            </Modal>
        </Container>
    );
}

export default App;
